import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  liveDetail: {
    _id: "",
    _user: "",
    __v: 0,
    createdAt: "",
    deviceType: "",
    information: {
      email: "",
      name: "",
      picture: "",
    },
    status: "",
    updatedAt: "",
    usage: "",
  },
};

// Live Detail Slice
const liveDetailSlice = createSlice({
  name: "liveDetail",
  initialState, // Correctly assign initial state
  reducers: {
    setLiveDetail: (state, { payload }) => {
      // console.log(payload, "payload");
      state.liveDetail = payload ?? initialState.liveDetail;
    },
  },
});

export const { setLiveDetail } = liveDetailSlice.actions;

export default liveDetailSlice.reducer;
